// extracted by mini-css-extract-plugin
export var box = "Tags-module--box--a4338";
export var box_md = "Tags-module--box_md--6e8f1";
export var box_xmd = "Tags-module--box_xmd--12c2f";
export var box_flex = "Tags-module--box_flex--5e003";
export var box_lg = "Tags-module--box_lg--960c6";
export var box_sm = "Tags-module--box_sm--e1284";
export var box_outer = "Tags-module--box_outer--be9cd";
export var box_whiteBg = "Tags-module--box_white-bg--1f7d9";
export var box_noMarginBottom = "Tags-module--box_no-margin-bottom--bc084";
export var box_noPadding = "Tags-module--box_no-padding--d16d5";
export var box_outerGray = "Tags-module--box_outer-gray--491d7";
export var box_dark = "Tags-module--box_dark--39e64";
export var box_zIndex = "Tags-module--box_z-index--33e8a";
export var box_zIndex6 = "Tags-module--box_z-index-6--6087f";
export var box_eventsWithLine = "Tags-module--box_events-with-line--fdb87";
export var box_featuresAo = "Tags-module--box_features-ao--e28a6";
export var box_verticalPaddings = "Tags-module--box_vertical-paddings--43353";
export var clearP = "Tags-module--clearP--03a76";
export var clearP_vc = "Tags-module--clearP_vc--74ff0";
export var container = "Tags-module--container--6274d";
export var tag = "Tags-module--tag--ed19f";
export var tooltip = "Tags-module--tooltip--fbfd4";
export var hiddenTags = "Tags-module--hiddenTags--d5300";
export var fadeInAnimation = "Tags-module--fadeInAnimation--9ba6a";
export var placeHolderShimmer = "Tags-module--placeHolderShimmer--df013";